module.exports = __webpack_public_path__ + "img/full7-min.799cf983.png";